import { gql } from '@apollo/client';

import { StudentActivity } from '@ts-core/modules/activities/types';
import { studentActivityFragment } from '../fragments';

export interface GetActivitiesQueryVariables {
  courseId: string;
}

export interface GetActivitiesQueryResult {
  activities: StudentActivity[];
}

export const getActivitiesQuery = gql`
  query GetActivitiesQuery($courseId: String!) {
    activities(courseId: $courseId) @rest(type: "Activity", path: "courses/{args.courseId}/activities") {
      ...StudentActivity
    }
  }
  ${studentActivityFragment}
`;
